export default __webpack_public_path__ + "3affb1a.png";